import React, { Component, useState } from "react";
import HttpService from "../../services/HttpService";
import "../../css/index.css";
import "../../css/Pages.css";
import fileDownload from "js-file-download";
import { useTranslation } from 'react-i18next';
//import { process.env.REACT_APP_API_URL } from "../Globals";
import Collapsible from "./Components/BetalingenCollapsible";

// Wrapper component to use hooks
const BetalingenPaginaWrapper = () => {
  const { t } = useTranslation();
  return <BetalingenPagina t={t} />;
};

class BetalingenPagina extends Component {
  state = {
    loading: false,
    error: null,
    betalingenStatus: null,
    abonnementData: null,
    postzegelData: null,
    month: new Date().getFullYear() + "-" + new Date().getMonth(),
  };
  componentDidMount() {
    const httpService = HttpService;
    httpService.configure();
    this.state.axios = httpService.getAxiosClient();

    let url = `/Betalingen`;
    this.setState({
      loading: true,
      betalingenStatus: null,
      error: null,
    });
    this.state.axios
      .get(url)
      .then((response) => {
        this.setState({
          betalingenStatus: response.data.betalingen,
          abonnementData: response.data.abonnementData,
          postzegelData: response.data.postzegelData,
          error: null,
          loading: false,
        });
      })
      .catch((err) => {
        this.setState({
          betalingenStatus: null,
          error: err.message,
          loading: false,
        });
      });
  }

  GetBetalingenExport() {
    let url =
      `/Betalingen?jaar=` +
      this.state.month.split("-")[0] +
      "&maand=" +
      this.state.month.split("-")[1] +
      "&export=true";
    this.setState({
      loading: true,
      error: null,
    });
    this.state.axios
      .get(url, "blob")
      .then((response) => {
        fileDownload(
          response.data,
          "BetalingenExport_" + this.state.month + ".xml"
        );

        this.setState({
          loading: false,
          error: null,
        });
      })
      .catch((err) => {
        this.setState({
          error:
            typeof err.response !== "undefined"
              ? err.response.data.message
              : err.message,
          loading: false,
        });
      });
  }

  RetryExport() {
    let url = `/Betalingen`;
    this.setState({
      loading: true,
      error: null,
    });
    this.state.axios
      .post(url)
      .then((response) => {
        this.setState({
          betalingenStatus: response.data.betalingen,
          error: null,
          loading: false,
        });
      })
      .catch((err) => {
        this.setState({
          error:
            typeof err.response !== "undefined"
              ? err.response.data.message
              : err.message,
          loading: false,
        });
      });
  }

  MonthSelected(evt) {
    this.state.month = evt.target.value;
    this.UpdateBetalingenInfo();
  }

  UpdateBetalingenInfo() {
    let url =
      `/Betalingen?jaar=` +
      this.state.month.split("-")[0] +
      "&maand=" +
      this.state.month.split("-")[1] +
      "&export=false";
    this.setState({
      loading: true,
      error: null,
    });
    this.state.axios
      .get(url)
      .then((response) => {
        this.setState({
          abonnementData: response.data.abonnementData,
          postzegelData: response.data.postzegelData,
          error: null,
          loading: false,
        });
      })
      .catch((err) => {
        this.setState({
          betalingenStatus: null,
          error: err.message,
          loading: false,
        });
      });
  }

  render() {
    if (
      !this.state.loading &&
      !this.state.error &&
      this.state.betalingenStatus != null
    ) {
      let betalingenStatus = this.state.betalingenStatus;
      let abonnementData = this.state.abonnementData;
      abonnementData = abonnementData.sort((a, b) =>
        a.count > b.count ? -1 : 1
      );
      let postzegelData = this.state.postzegelData;
      postzegelData = postzegelData.sort((a, b) =>
        a.count > b.count ? -1 : 1
      );
      return (
        <div className="page-wrapper">
          <div className="page-header">
            <h2>{this.props.t('payments.title')}</h2>
          </div>
          <div className="page-content">
            <div className="filter-bar">
              <h3>{this.props.t('payments.lastExport')}</h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', maxWidth: '500px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                  <label style={{ fontWeight: '600', minWidth: '120px' }}>{this.props.t('payments.date')}:</label>
                  <input
                    type="text"
                    readOnly
                    value={betalingenStatus.datum || ""}
                    style={{ backgroundColor: '#e5e7eb', color: '#111827', cursor: 'not-allowed', width: '200px' }}
                  />
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                  <label style={{ fontWeight: '600', minWidth: '120px' }}>{this.props.t('subscriptions.status')}:</label>
                  <input
                    type="text"
                    readOnly
                    value={`${betalingenStatus.http_code} ${betalingenStatus.http_bericht}`}
                    style={{ backgroundColor: '#e5e7eb', color: '#111827', cursor: 'not-allowed', width: '200px' }}
                  />
                </div>
              </div>
            </div>

            <div className="filter-bar">
              <h3>{this.props.t('payments.manualExport')}</h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', maxWidth: '500px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                  <label style={{ fontWeight: '600', minWidth: '120px' }}>{this.props.t('dashboard.period')}:</label>
                  <input
                    type="month"
                    onChange={(evt) => this.MonthSelected(evt)}
                    defaultValue={this.state.month}
                    className="filter-input"
                    style={{ width: '200px' }}
                  />
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <button
                    className="btn btn-primary"
                    onClick={() => this.GetBetalingenExport()}
                    style={{ padding: '0.375rem 0.75rem', fontSize: '0.875rem' }}
                  >
                    {this.props.t('payments.export')}
                  </button>
                  <button
                    className="btn btn-primary"
                    onClick={() => this.RetryExport()}
                    style={{ padding: '0.375rem 0.75rem', fontSize: '0.875rem' }}
                  >
                    {this.props.t('payments.retry')}
                  </button>
                </div>
              </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2rem', marginTop: '2rem' }}>
              <div>
                <h3 style={{ fontWeight: '700', marginBottom: '1rem' }}>{this.props.t('payments.subscriptions')}</h3>
                <div className="table-wrapper">
                  <div className="table-scroll">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>{this.props.t('payments.name')}</th>
                          <th>{this.props.t('payments.quantity')}</th>
                        </tr>
                      </thead>
                      {abonnementData.map((abo) => (
                        <Collapsible key={abo.id} item={abo} />
                      ))}
                    </table>
                  </div>
                </div>
              </div>
              <div>
                <h3 style={{ fontWeight: '700', marginBottom: '1rem' }}>{this.props.t('payments.stamps')}</h3>
                <div className="table-wrapper">
                  <div className="table-scroll">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>{this.props.t('payments.name')}</th>
                          <th>{this.props.t('payments.quantity')}</th>
                        </tr>
                      </thead>
                      {postzegelData.map((zegel) => (
                        <Collapsible key={zegel.id} item={zegel} />
                      ))}
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
    if (this.state.error) {
      return (
        <div className="error-alert">
          <h3>Fout</h3>
          <p>Er is iets mis gegaan: {this.state.error}</p>
        </div>
      );
    }
    if (this.state.loading) {
      return (
        <div className="loading-container">
          <div className="loading-text">Laden...</div>
        </div>
      );
    }
    return (
      <div className="error-alert">
        <h3>Betalingen niet beschikbaar</h3>
        <p>Probeer het later opnieuw.</p>
      </div>
    );
  }
}
export default BetalingenPaginaWrapper;
